// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#ffb601","btn":"Button_btn__3u62g","outline":"Button_outline__2fD_Y","btnLoading":"Button_btnLoading__2MGPU"};